import { Component, OnInit } from '@angular/core';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { EmailConfirmationModel } from 'src/app/Elearning-Models';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss']
})
export class EmailConfirmationComponent implements OnInit {

  dataService: CurriculumService;
  dataReceived: boolean = false;

  data: EmailConfirmationModel;
  dataFail: boolean = false;
  emailSent: boolean = false;
  emailSending: boolean = false;

  guid: string;
  
  constructor(
    private serviceFactory: IServiceFactory,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.dataService = serviceFactory.getCurriculumService();
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {

      this.guid = params.get('guid');

      this.onConfirmEmail();

    });
  }

  private onConfirmEmail() {
    this.dataService.ConfirmEmail(this.guid).subscribe(result => {
      if (result) {
        this.data = result;

        if (this.data.Success) {
          setTimeout(() => window.location.href = "/ELearning/Curriculum", 5000);
        }
        else {
          this.dataFail = true;
        }
        this.dataReceived = true;
      }
      else {
        this.toastr.error("Could not confirm email at this time.", "Please try again.");
        this.dataFail = true;
      }
    });
  }

  resendConfirmationEmail(){
    if(this.emailSending){
      return;
    }
    this.emailSending = true;
    this.dataService.ResendConfirmationEmail(this.guid).subscribe(result => {
      if(result){
        this.toastr.success("Email Sent.", "You have 24 hours to confirm your email.");
        this.emailSent = true;
      }
      else{
        this.toastr.error("Could not send an email at this time.", "Please try again.");
      }
      this.emailSending = false;
    });
  }

}
